import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage } = useLanguage();

  // Nombres de idiomas traducidos según el idioma activo
  const languageNames = {
    es: {
      es: 'Español',
      en: 'Inglés',
      eus: 'Euskera',
      ca: 'Catalán',
      gl: 'Gallego',
      de: 'Alemán',
      fr: 'Francés',
      it: 'Italiano',
      pt: 'Portugués',
      ru: 'Ruso',
      no: 'Noruego',
      ar: 'Árabe',
      zh: 'Chino Simplificado',
      zh_TW: 'Chino Tradicional',
      ja: 'Japonés',
      ko: 'Coreano'
    },
    en: {
      es: 'Spanish',
      en: 'English',
      eus: 'Basque',
      ca: 'Catalan',
      gl: 'Galician',
      de: 'German',
      fr: 'French',
      it: 'Italian',
      pt: 'Portuguese',
      ru: 'Russian',
      no: 'Norwegian',
      ar: 'Arabic',
      zh: 'Chinese (Simplified)',
      zh_TW: 'Chinese (Traditional)',
      ja: 'Japanese',
      ko: 'Korean'
    },
    eus: {
      es: 'Gaztelera',
      en: 'Ingelesa',
      eus: 'Euskara',
      ca: 'Katalana',
      gl: 'Galiziera',
      de: 'Alemana',
      fr: 'Frantsesa',
      it: 'Italiera',
      pt: 'Portugesa',
      ru: 'Errusiera',
      no: 'Norvegiera',
      ar: 'Arabiera',
      zh: 'Txinera (Sinplifikatua)',
      zh_TW: 'Txinera (Tradizionala)',
      ja: 'Japoniera',
      ko: 'Koreera'
    },
    ca: {
      es: 'Espanyol',
      en: 'Anglès',
      eus: 'Basc',
      ca: 'Català',
      gl: 'Gallec',
      de: 'Alemany',
      fr: 'Francès',
      it: 'Italià',
      pt: 'Portuguès',
      ru: 'Rus',
      no: 'Noruec',
      ar: 'Àrab',
      zh: 'Xinès Simplificat',
      zh_TW: 'Xinès Tradicional',
      ja: 'Japonès',
      ko: 'Coreà'
    },
    gl: {
      es: 'Español',
      en: 'Inglés',
      eus: 'Éuscaro',
      ca: 'Catalán',
      gl: 'Galego',
      de: 'Alemán',
      fr: 'Francés',
      it: 'Italiano',
      pt: 'Portugués',
      ru: 'Ruso',
      no: 'Noruegués',
      ar: 'Árabe',
      zh: 'Chinés Simplificado',
      zh_TW: 'Chinés Tradicional',
      ja: 'Xaponés',
      ko: 'Coreano'
    },
    de: {
      es: 'Spanisch',
      en: 'Englisch',
      eus: 'Baskisch',
      ca: 'Katalanisch',
      gl: 'Galicisch',
      de: 'Deutsch',
      fr: 'Französisch',
      it: 'Italienisch',
      pt: 'Portugiesisch',
      ru: 'Russisch',
      no: 'Norwegisch',
      ar: 'Arabisch',
      zh: 'Chinesisch (Vereinfacht)',
      zh_TW: 'Chinesisch (Traditionell)',
      ja: 'Japanisch',
      ko: 'Koreanisch'
    },
    fr: {
      es: 'Espagnol',
      en: 'Anglais',
      eus: 'Basque',
      ca: 'Catalan',
      gl: 'Galicien',
      de: 'Allemand',
      fr: 'Français',
      it: 'Italien',
      pt: 'Portugais',
      ru: 'Russe',
      no: 'Norvégien',
      ar: 'Arabe',
      zh: 'Chinois Simplifié',
      zh_TW: 'Chinois Traditionnel',
      ja: 'Japonais',
      ko: 'Coréen'
    },
    it: {
      es: 'Spagnolo',
      en: 'Inglese',
      eus: 'Basco',
      ca: 'Catalano',
      gl: 'Galiziano',
      de: 'Tedesco',
      fr: 'Francese',
      it: 'Italiano',
      pt: 'Portoghese',
      ru: 'Russo',
      no: 'Norvegese',
      ar: 'Arabo',
      zh: 'Cinese Semplificato',
      zh_TW: 'Cinese Tradizionale',
      ja: 'Giapponese',
      ko: 'Coreano'
    },
    pt: {
      es: 'Espanhol',
      en: 'Inglês',
      eus: 'Basco',
      ca: 'Catalão',
      gl: 'Galego',
      de: 'Alemão',
      fr: 'Francês',
      it: 'Italiano',
      pt: 'Português',
      ru: 'Russo',
      no: 'Norueguês',
      ar: 'Árabe',
      zh: 'Chinês Simplificado',
      zh_TW: 'Chinês Tradicional',
      ja: 'Japonês',
      ko: 'Coreano'
    },
    ru: {
      es: 'Испанский',
      en: 'Английский',
      eus: 'Баскский',
      ca: 'Каталанский',
      gl: 'Галисийский',
      de: 'Немецкий',
      fr: 'Французский',
      it: 'Итальянский',
      pt: 'Португальский',
      ru: 'Русский',
      no: 'Норвежский',
      ar: 'Арабский',
      zh: 'Китайский (Упрощённый)',
      zh_TW: 'Китайский (Традиционный)',
      ja: 'Японский',
      ko: 'Корейский'
    },
    no: {
      es: 'Spansk',
      en: 'Engelsk',
      eus: 'Baskisk',
      ca: 'Katalansk',
      gl: 'Galisisk',
      de: 'Tysk',
      fr: 'Fransk',
      it: 'Italiensk',
      pt: 'Portugisisk',
      ru: 'Russisk',
      no: 'Norsk',
      ar: 'Arabisk',
      zh: 'Kinesisk (Forenklet)',
      zh_TW: 'Kinesisk (Tradisjonell)',
      ja: 'Japansk',
      ko: 'Koreansk'
    },
    ar: {
      es: 'الإسبانية',
      en: 'الإنجليزية',
      eus: 'الباسكية',
      ca: 'الكتالونية',
      gl: 'الجاليكية',
      de: 'الألمانية',
      fr: 'الفرنسية',
      it: 'الإيطالية',
      pt: 'البرتغالية',
      ru: 'الروسية',
      no: 'النرويجية',
      ar: 'العربية',
      zh: 'الصينية المبسطة',
      zh_TW: 'الصينية التقليدية',
      ja: 'اليابانية',
      ko: 'الكورية'
    },
    zh: {
      es: '西班牙语',
      en: '英语',
      eus: '巴斯克语',
      ca: '加泰罗尼亚语',
      gl: '加利西亚语',
      de: '德语',
      fr: '法语',
      it: '意大利语',
      pt: '葡萄牙语',
      ru: '俄语',
      no: '挪威语',
      ar: '阿拉伯语',
      zh: '简体中文',
      zh_TW: '繁體中文',
      ja: '日语',
      ko: '韩语'
    },
    zh_TW: {
      es: '西班牙語',
      en: '英語',
      eus: '巴斯克語',
      ca: '加泰隆尼亞語',
      gl: '加利西亞語',
      de: '德語',
      fr: '法語',
      it: '義大利語',
      pt: '葡萄牙語',
      ru: '俄語',
      no: '挪威語',
      ar: '阿拉伯語',
      zh: '簡體中文',
      zh_TW: '繁體中文',
      ja: '日語',
      ko: '韓語'
    },
    ja: {
      es: 'スペイン語',
      en: '英語',
      eus: 'バスク語',
      ca: 'カタルーニャ語',
      gl: 'ガリシア語',
      de: 'ドイツ語',
      fr: 'フランス語',
      it: 'イタリア語',
      pt: 'ポルトガル語',
      ru: 'ロシア語',
      no: 'ノルウェー語',
      ar: 'アラビア語',
      zh: '簡体字中国語',
      zh_TW: '繁体字中国語',
      ja: '日本語',
      ko: '韓国語'
    },
    ko: {
      es: '스페인어',
      en: '영어',
      eus: '바스크어',
      ca: '카탈루냐어',
      gl: '갈리시아어',
      de: '독일어',
      fr: '프랑스어',
      it: '이탈리아어',
      pt: '포르투갈어',
      ru: '러시아어',
      no: '노르웨이어',
      ar: '아랍어',
      zh: '중국어 (간체)',
      zh_TW: '중국어 (번체)',
      ja: '일본어',
      ko: '한국어'
    }
  };

  const languages = [
    'es', 'en', 'eus', 'ca', 'gl', 'de', 'fr', 'it', 
    'pt', 'ru', 'no', 'ar', 'zh', 'zh_TW', 'ja', 'ko'
  ];

  return (
    <div className="language-selector">
      <select
        value={currentLanguage}
        onChange={(e) => changeLanguage(e.target.value)}
        aria-label="Selector de idioma"
      >
        {languages.map((lang) => (
          <option key={lang} value={lang}>
            {languageNames[currentLanguage]?.[lang] || languageNames.es[lang]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
